import React from 'react';
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const RowsScriptsIndicator = ({rowsScripts}) => (
    rowsScripts && rowsScripts.length > 0 ? (
        <span>
            <FontAwesomeIcon icon="filter" />
        </span>
    ) : null
);

RowsScriptsIndicator.propTypes = {
    rowsScripts: PropTypes.array,
};

export default RowsScriptsIndicator;
